import React from 'react'
import ConfirmMailContent from './components/ConfirmMailContent'

const ConfirmMail = () => {
  return (
    <div className="text-center">
        <ConfirmMailContent  titleTag="h3" />
      </div>
  )
}

export default ConfirmMail